<template>
<el-dialog :title="msg('采购单号')" :visible.sync="visible" 
    :fullscreen="isMinScreen"
    :close-on-click-modal="false"
    width="700">
<el-form label-width="100px">
    <el-row> 
        <el-col :xs="24" :sm="12">
            <div style="margin-left:20px;margin-top:10px;margin-bottom:20px;">
                <span>请点击采购完成获取采购单号<el-button id="syb_finish_buy_btn" type="success" size="mini"  @click="finishBuy()">{{msg('采购完成')}}</el-button></span>
            </div>
        </el-col>
        <el-col :xs="24" :sm="12">
            <div style="margin-left:20px;margin-top:10px;margin-bottom:20px;">
                <span style="font-size:12px">获取不到采购单号时请检查是否有正常登录：<el-link type="primary" :underline="false" @click="doPurchaseLogin">去登录</el-link></span>
            </div>
        </el-col>
    </el-row>
    <el-row>
        <el-col :xs="24" :sm="8">
            <el-form-item :label="msg('采购单号')" label-width="100px">
                <el-input 
                    v-model="code" style="margin-top:0px;" size="small">
                </el-input>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
            <el-form-item :label="msg('采购平台')" label-width="100px">
                <el-select v-model="type" placeholder="平台" size="mini">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <!-- <el-input 
                    v-model="type" style="margin-top:0px;" size="small">
                </el-input> -->
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
            <el-form-item :label="msg('预估单件成本')" label-width="100px">
                <el-input 
                    v-model="price" style="margin-top:0px;" size="small">
                </el-input>
            </el-form-item>
        </el-col>
    </el-row>

    <div style="text-align:center; margin-top: 1px;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="close">{{msg('取消')}}</el-button>
    </div>  

    <el-row>
        <el-table :data="batchs" style="width: 100%;margin-top: 10px;" size="small" ref="dataTable" max-height="400" stripe>
          <el-table-column label="其他采购单号">
            <!-- <el-table-column type="selection" min-width="55"></el-table-column> -->
            <el-table-column prop="created" :label="msg('采购时间')" min-width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="code" :label="msg('采购单号')" min-width="130" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="title" :label="msg('标题')" min-width="120" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="spec" :label="msg('规格')" min-width="80" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="amount" :label="msg('订单金额')" min-width="60" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="type" :label="msg('平台')" min-width="60" :show-overflow-tooltip="true" sortable="true"></el-table-column>
            <el-table-column
                fixed="right"
                :label="msg('操作')"
                width="60">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">选择</el-button>
                </template>
            </el-table-column>
          </el-table-column>
        </el-table>
    </el-row> 
</el-form> 
<stock-detail-purchase-login ref="purchasLoginDg"/>
</el-dialog>
</template>

<script>
import StockDetailPurchaseLogin from "../store/StockDetailPurchaseLogin.vue";

export default {
    name: 'OrderFinishbuy',
    components:{
        StockDetailPurchaseLogin:StockDetailPurchaseLogin
    },
    data(){
        return{
            visible: false,
            batchs:[],
            code:null,
            sinceTime:null,
            type:null,
            created:null,
            price:null,
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ], 
            platform:null,
        }
    }, 
    props: {
        stocks: {  //[{stockId, detailId, qty},{stockId, detailId, qty}]
            type: Array
        }
    },
    computed:{ 
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    mounted: function(){
    },
    methods:{
        showDialog(platform){
            this.visible = true;
            this.batchs= [];
            this.platform = platform;
            this.code = null;
            this.type = null;
            this.created = null;
            this.price = null,
            this.sinceTime = new Date();
        },
        onSubmit(){
            if(!this.code){
                this.$message(this.msg('订单编号不能为空'));
            }
            if(!this.type){
                this.$message(this.msg('平台不能为空'));
            }
            this.doSavePurchase();
        },
        finishBuy(){
            var _this = this;

            let extId = document.body.getAttribute('ba-ext-id');
            /* global chrome */
            const requestId = 'req_' + Date.now() + '_' + Math.random().toString(36).slice(2);
            chrome.runtime.sendMessage(extId, {
                action: 'orders',
                type: this.platform,
                requestId
            }, response => {
                if (!response) return;
                if (response.requestId !== undefined && response.requestId !== requestId) return;
                if (response.success) {
                    // console.log('订单数据:', response.data);
                    let data = response.data;
                    if(data && data.length > 0){

                        data.forEach(e => {
                            let code = e.orderId;
                            let spec = e.details[0].spec;
                            let price = e.details[0].price;
                            let amount = e.amount;
                            let created = e.createdAt;

                            let res = {
                                code:code,
                                title:'',
                                spec:spec,
                                price:price,
                                amount: amount,
                                created:created,
                                type:this.platform=='1688'?"alibaba":this.platform
                            }
                            _this.batchs.push(res);
                        })

                        //将batchs按照时间顺序进行排序
                        let len = _this.batchs.length;
                        for (let i = 0; i < len; i++) {
                            for (let j = 0; j < len - 1- i; j++) {
                                let batch1 = _this.batchs[j];
                                let batch2 = _this.batchs[j+1];
                                var oDate1 = new Date(batch1.created);
                                var oDate2 = new Date(batch2.created);
                                if(oDate1.getTime() < oDate2.getTime()){
                                    let temp = _this.batchs[j];
                                    _this.batchs[j] = _this.batchs[j+1];
                                    _this.batchs[j+1] = temp;
                                }
                            }
                        }
                        _this.code = _this.batchs[0].code;
                        _this.type = _this.batchs[0].type;
                        _this.price = _this.batchs[0].amount;
                        _this.created = _this.batchs[0].created;
                    }
                }else{
                    this.$message(this.msg('获取订单数据失败'));
                }
            });
        },
        handleClick(row){
            this.code = row.code;
            this.type = row.type;
            this.created = row.created;
            this.price = row.amount;
        },
        doPurchaseLogin(){
            this.$refs.purchasLoginDg.showDialog();
        },
        doSavePurchase(){
            if(this.stocks.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            if(!this.code){
                this.$message(this.msg('采购单号不存在'));
                return;
            }
            if(!this.type){
                this.$message(this.msg('请选择采购平台'));
                return;
            }
            let cost = 0;
            let resCost = this.price;
            if(resCost){
                cost = (resCost*100).toFixed(0);
            }
            let para = [];
            this.stocks.forEach(e=>{
                para.push({
                    id:e.detailId,
                    stockId:e.stockId,
                    cost: cost*1
                })
            })
            this.$axios.post(this.$kit.api.stockDetail.updateDetailPurchaseCodes
                +"?code="+this.code
                +"&u=1"
                +"&type="+this.type
                +"&created="+this.created,
                para
            ).then((result) => {
                if(result.status){
                    this.close();
                }
                this.$message(result.msg);
            });
        },
        close(){
            this.visible = false;
            this.$emit('finish');
        }
    
    }
}
</script>

<style scoped lang="scss">

</style>
